import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const [FileUploadProvider, useFileUploadContext] = buildGlobalReferenceContext("FileUpload");

export { FileUploadProvider, useFileUploadContext };
//# sourceMappingURL=context.mjs.map
